import { Row, Col } from "antd";
import TopClanci from "../Statistika/TopDesetClanaka";
import TopDokumenti from "../Statistika/TopDesetDokumenata";
import NajposjecenijiClanci from "./NajposjecenijiClanci";
import NajposjecenijiDokumenti from "./NajposjecenijiDokumenti";
import "./HomePage.css"
import Background from "../../components/Background4";

const HomePage = () => {
  return (
    <div className="homepage">
      <Background />
    
      <Row>
        <div className="homepage-lijevo">
      <Col
        gutter={[24, 24]}
        justify="center"
        wrap
        style={{ marginBottom: "32px" }}
      >
        <Row xs={24} sm={24} md={12} lg={12} xl={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TopClanci />
        </Row>
        <Row xs={24} sm={24} md={12} lg={12} xl={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <NajposjecenijiClanci />
        </Row>
      </Col>
      </div>

      <div className="homepage-desno">    
      <Col gutter={[24, 24]} justify="center" wrap>
        <Row xs={24} sm={24} md={12} lg={12} xl={12}>
          <TopDokumenti />
        </Row>
        <Row xs={24} sm={24} md={12} lg={12} xl={12}>
          <NajposjecenijiDokumenti/>
        </Row>
      </Col>
      </div>
      </Row> 
    </div>
  );
};

export default HomePage;